import { render } from "./index.vue?vue&type=template&id=567fe1e0"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=567fe1e0&lang=css"

import exportComponent from "/Users/rithy/Documents/code/vpos.club/vpos-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__